import axios from 'axios';
import window from 'global/window';
import ipRangeCheck from 'ip-range-check';
import events from '~variables/custom-events.json';
import { fireCustomEvent } from '~helpers/custom-events';
import { setItem, getItem } from '~helpers/storage';
import { Hosts } from '~helpers/environments';

const officeIpList = [
  // Office London
  '80.169.174.18/29',
  // London WeWork
  '80.169.194.69',
  // Office Shanghai
  '180.168.151.57/29',
  // Office Shanghai VPN
  '103.215.2.86',
  '103.215.2.87',
  '103.215.2.88',
  '103.215.2.89',
  '103.215.2.90',
  '103.215.2.91',
  '103.215.2.92',
  '103.215.2.93',
  '103.215.2.94',
  // New Shanghai office ip from 07/16,2020
  '69.172.73.10',
  '103.114.193.246',
];

const getClientInfo = () => {
  const storageKey = 'clientInfo';
  const storageData = getItem(storageKey, 'session') || null;

  window.hurricane = window.hurricane || {};

  if (storageData) {
    window.hurricane.clientInfo = storageData;
    fireCustomEvent(events.clientInfo.name);
    if (window.hurricane.clientInfo?.ip) {
      window.hurricane.isOfficeUser = ipRangeCheck(window.hurricane.clientInfo?.ip, officeIpList);
    }
    return true;
  }

  return axios
    .get(`https:${Hosts.authUrl}microapp-home-page/get-client-info`)
    .then(response => {
      window.hurricane.clientInfo = response.data;
      setItem(storageKey, response.data, 'session');
      fireCustomEvent(events.clientInfo.name);
      if (window.hurricane.clientInfo?.ip) {
        window.hurricane.isOfficeUser = ipRangeCheck(window.hurricane.clientInfo?.ip, officeIpList);
      }
    })
    .catch(() => {
      window.hurricane.clientInfo = window.hurricane.clientInfo || {};
      window.hurricane.isOfficeUser = false;
    });
};

export default getClientInfo;
